module.exports = __webpack_public_path__ + "static/media/incident_category-public_holidays.00815eb7.svg";